//#region src/assets/banks/bank-gyt.svg
var bank_gyt_default = "" + new URL("../bank-gyt-J8lQtcz3.svg", import.meta.url).href;
//#endregion
export { bank_gyt_default as default };

//# sourceMappingURL=bank-gyt.js.map